// UI-3: FloatingAsk, the floating "Ask" button. design-brief.md section 2.5 (58x58, radius 18,
// highlight green, 1px line, rotates -6deg on hover with a mouse); mobile-responsive-addendum.md
// 6 (52x52 on a phone, 16px in from the right and above the home indicator; hidden while any
// modal, sheet, drawer or the chat itself is open, and on the Aidey Chat page).
//
// It opens the EXISTING chat popup, through the 'aidey:open-chat' event App.js already listens
// for (the same handler a notification's "Ask Aidey" uses). It never opens the chat by itself
// (decision 40): the only thing that sends the event is a press. data-tour-id is kept, so the
// guided tour that points at the bubble still finds it. UI-4 swaps it into the app.
import React, { useEffect, useState } from 'react';
import { useAnyOverlayOpen } from './Overlay';
import './v2.css';

// True while the chat popup (App.js's .aidey-popup-container) is on the page.
export function useChatOpen() {
  const find = () => (typeof document !== 'undefined' && !!document.querySelector('.aidey-popup-container'));
  const [open, setOpen] = useState(find);
  useEffect(() => {
    if (typeof MutationObserver === 'undefined') return undefined;
    const obs = new MutationObserver(() => setOpen(find()));
    obs.observe(document.body, { childList: true, subtree: true });
    return () => obs.disconnect();
  }, []);
  return open;
}

export function openChat() {
  window.dispatchEvent(new CustomEvent('aidey:open-chat', { detail: { message: '' } }));
}

// hidden: the page says so (the Aidey Chat page). contained: positioned inside its parent rather
// than the window (the UI kit, where the old bubble is still in the corner until UI-4).
export function FloatingAsk({ hidden = false, contained = false, label = 'Ask Aidey' }) {
  const overlay = useAnyOverlayOpen();
  const chat = useChatOpen();
  if (hidden || overlay || chat) return null;
  return (
    <button type="button" className={`ui-ask${contained ? ' ui-ask--contained' : ''}`} data-tour-id="dashboard-chat-bubble"
      aria-label={label} onClick={openChat}>
      <span aria-hidden="true">Aidey</span>
    </button>
  );
}
